import { useAppState } from './useAppState';

export function usePreferences() {
  const { state, dispatch } = useAppState();

  const open = () => dispatch({ type: 'OPEN_PREFERENCES' });
  const close = () => dispatch({ type: 'CLOSE_PREFERENCES' });
  const setSections = (sections) =>
    dispatch({ type: 'SET_SECTIONS', payload: { sections } });
  const setAuthors = (authors) =>
    dispatch({ type: 'SET_AUTHORS', payload: { authors } });
  const setFollowingEnabled = (followingEnabled) =>
    dispatch({ type: 'SET_FOLLOWING_ENABLED', payload: { followingEnabled } });

  return {
    isOpen: state.preferences.isOpen,
    sections: state.preferences.sections,
    authors: state.preferences.authors,
    followingEnabled: state.preferences.followingEnabled,
    open,
    close,
    setSections,
    setAuthors,
    setFollowingEnabled,
  };
}
